module.exports = __webpack_public_path__ + "img/arrow-right.5cfb7a73.png";